import { el } from "../core/dom";
import type { ProductPolicyLineOptions } from "../types";

export function renderProductPolicyLine({
  label,
  links,
  linkStyle,
}: ProductPolicyLineOptions): HTMLElement {
  const line = el(
    "span",
    { id: "product-privacy-policies" },
    el("span", { id: "product-privacy-policies-label" }, label),
    " "
  );
  links.forEach((link, index) => {
    if (index > 0) line.appendChild(document.createTextNode(", "));
    line.appendChild(
      el(
        "a",
        {
          id: `product-privacy-policy-${link.uuid}`,
          href: link.url,
          target: "_blank",
          rel: "noopener noreferrer",
          style: linkStyle,
        },
        link.name
      )
    );
  });
  return line;
}
